"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container002Styled = exports.ResultDetailStyled = exports.TestDetailStyled = void 0;
const styled_components_1 = __importStar(require("styled-components"));
exports.TestDetailStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: ${({ $isDesktop }) => (!$isDesktop ? '14px' : '0px')};
	width: 100%;
	padding: ${({ $isDesktop }) => (!$isDesktop ? '20px 20px 0px 20px' : '0px')};

	.test-info-panel {
		border-radius: 12px;
		background: #f5f6f9;
		overflow: hidden;
		width: 100%;
	}

	.test-info-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: ${({ $isDesktop }) => (!$isDesktop ? '12px 14px' : '14px 18px')};
	}

	.test-info-title {
		font-size: ${({ $isDesktop }) => (!$isDesktop ? '16px' : '20px')};
		line-height: ${({ $isDesktop }) => (!$isDesktop ? '20px' : '30px')};
		font-weight: 700;
		color: var(--color-black, #101010);
	}

	.test-info-toggle {
		border: none;
		background: transparent;
		cursor: pointer;
		line-height: 1;
		padding: 2px;
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}

	.test-info-toggle.folded .test-info-toggle-icon {
		transform: rotate(-90deg);
	}

	.test-info-toggle.expanded .test-info-toggle-icon {
		transform: rotate(90deg);
	}

	.test-info-body {
		padding: ${({ $isDesktop }) => (!$isDesktop ? '14px' : '16px 20px')};
		display: grid;
		grid-template-columns: ${({ $isDesktop }) => (!$isDesktop ? '1fr' : '1fr 1fr')};
		gap: ${({ $isDesktop }) => (!$isDesktop ? '10px' : '12px 18px')};
		border-top: 1px solid var(--color-grey-c, #e6e8ed);
	}

	.info-field {
		display: flex;
		align-items: center;
		gap: 10px;
		font-size: ${({ $isDesktop }) => (!$isDesktop ? '15px' : '17px')};
		line-height: ${({ $isDesktop }) => (!$isDesktop ? '24px' : '28px')};
		color: var(--color-black, #101010);
	}

	.info-label {
		min-width: ${({ $isMobile }) => ($isMobile ? '60px' : '88px')};
		font-weight: 700;
	}

	.info-value {
		min-width: 0;
		word-break: break-word;
	}

	.info-links {
		display: flex;
		align-items: center;
		gap: 10px;
		flex-wrap: wrap;
	}

	.info-link {
		color: var(--color-black, #101010);
		text-decoration: underline;
		cursor: pointer;
	}
`;
exports.ResultDetailStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: ${({ $isMobile }) => ($isMobile ? '14px' : '16px')};
	width: 100%;

	.result-card {
		background: var(--color-white, #ffffff);
		padding: ${({ $isDesktop }) => (!$isDesktop ? '20px' : '0px')};
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.summary-title-row {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
	}

	.tab-content-wrap {
		display: flex;
		flex-direction: column;
		gap: 16px;
	}

	.summary-title {
		font-size: ${({ $isMobile }) => ($isMobile ? '14px' : '20px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '20px' : '30px')};
		font-weight: 700;
		color: var(--color-black, #101010);
	}

	.subject-member-count {
		font-size: ${({ $isMobile }) => ($isMobile ? '14px' : '16px')};
		line-height: 24px;
		color: var(--color-grey, #666666);
		white-space: nowrap;
	}

	.summary-grid {
		display: grid;
		grid-template-columns: ${({ $isMobile }) => ($isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))')};
		gap: 14px;
	}

	.summary-card {
		border: 1px solid var(--color-grey-c, #e6e8ed);
		border-radius: 12px;
		background: var(--color-white, #ffffff);
		padding: ${({ $isMobile }) => ($isMobile ? '14px' : '16px 18px')};
		display: flex;
		flex-direction: column;
		gap: 14px;
	}

	.summary-table {
		border-top: 1px solid var(--color-grey-c, #e6e8ed);
		padding-top: 16px;
		width: 100%;
	}

	.card-title {
		font-size: ${({ $isMobile }) => ($isMobile ? '14px' : '20px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '22px' : '28px')};
		font-weight: 700;
		color: var(--color-black, #101010);
	}

	.chart-metric-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: ${({ $isMobile }) => ($isMobile ? '14px' : '20px')};
		flex: 1;
	}

	.pie-wrap {
		flex-shrink: 0;
	}

	.metric-list {
		display: flex;
		flex-direction: column;
		gap: 8px;
		min-width: 0;
		width: 100%;
	}

	.metric-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 8px;
	}

	.metric-label {
		font-size: ${({ $isMobile }) => ($isMobile ? '13px' : '15px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '20px' : '24px')};
		font-weight: 700;
		color: var(--color-black, #101010);
		white-space: nowrap;
		flex-shrink: 0;
	}

	.metric-value {
		font-size: ${({ $isMobile }) => ($isMobile ? '14px' : '18px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '22px' : '28px')};
		font-weight: 700;
		color: #101010;
		white-space: nowrap;
		flex-shrink: 0;
		text-align: right;
	}

	.avg-row {
		display: grid;
		grid-template-columns: ${({ $isMobile, $isTablet }) => ($isMobile || $isTablet ? '1fr' : 'repeat(2, minmax(0, 1fr))')};
		gap: 12px;
	}

	.avg-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		min-width: 0;
		overflow: hidden;
	}

	.avg-value-group {
		display: inline-flex;
		align-items: center;
		gap: 4px;
		white-space: nowrap;
		flex-shrink: 0;
	}

	.avg-value,
	.upper-value {
		font-size: ${({ $isMobile }) => ($isMobile ? '14px' : '18px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '22px' : '28px')};
		font-weight: 700;
		color: #101010;
		white-space: nowrap;
	}

	.upper-row {
		display: grid;
		grid-template-columns: ${({ $isMobile, $isTablet }) => ($isMobile || $isTablet ? '1fr' : 'repeat(2, minmax(0, 1fr))')};
		gap: 12px;
	}

	.upper-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
		min-width: 0;
		overflow: hidden;
	}

	.upper-link {
		border: none;
		background: transparent;
		color: #101010;
		font-size: ${({ $isMobile }) => ($isMobile ? '16px' : '22px')};
		line-height: 1;
		padding: 0;
		cursor: pointer;
	}

	/* 등급별 인원 분포 — "1등급 10명 | 2등급 20명 | …" (라벨 왼쪽·굵은 값 오른쪽, 칸 사이 구분선).
	   화면별 고정 열 수 grid: 데스크탑 5열(=20% 균등 1행) / 태블릿 3열 / 모바일 2열 —
	   고정 %폭은 좁은 화면에서 콘텐츠 최소폭보다 작아져 잘렸고(실기기), 열 수가 고정이면
	   잘림이 원천 차단되고 "행 첫 칸 구분선 제거"도 nth-child 로 결정적으로 처리된다. */
	.tier-row {
		display: grid;
		grid-template-columns: ${({ $isMobile, $isTablet }) => $isMobile ? 'repeat(2, minmax(0, 1fr))' : $isTablet ? 'repeat(3, minmax(0, 1fr))' : 'repeat(5, minmax(0, 1fr))'};
		row-gap: 8px;
	}

	.tier-item {
		display: flex;
		align-items: center;
		justify-content: space-between; /* 칸 안에서 라벨 왼쪽·값 오른쪽 끝 */
		gap: 8px;
		min-width: 0;
		padding: 0 ${({ $isMobile }) => ($isMobile ? '10px' : '14px')};
		border-left: 1px solid #e0e3e8;
		white-space: nowrap;
	}

	${({ $isMobile, $isTablet }) => {
    const cols = $isMobile ? 2 : $isTablet ? 3 : 5;
    return `
	.tier-item:nth-child(${cols}n + 1) {
		border-left: none;
		padding-left: 0;
	}
	.tier-item:nth-child(${cols}n),
	.tier-item:last-child {
		padding-right: 0;
	}
		`;
}}

	.tier-label {
		font-size: ${({ $isMobile }) => ($isMobile ? '12px' : '13px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '20px' : '22px')};
		color: #101010;
	}

	.tier-value {
		font-size: ${({ $isMobile }) => ($isMobile ? '13px' : '14px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '20px' : '22px')};
		font-weight: 700;
		color: #101010;
	}
`;
exports.Container002Styled = styled_components_1.default.div `
	.txt {
		color: var(--color-black, #101010);
		text-align: right;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: var(--b4-font-size, 14px);
		line-height: var(--b4-line-height, 22px);
		letter-spacing: var(--b4-letter-spacing, -0.02em);
		font-weight: var(--b4-font-weight, 400);
		position: relative;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;

		.txt-span4 {
			color: var(--color-black, #101010);
			font-family: 'Noto Sans KR', sans-serif;
			font-size: ${({ $isDesktop }) => $isDesktop ? ` var(--b3-font-size, 16px)` : `var(--b4-font-size, 14px)`};
			line-height: ${({ $isDesktop }) => $isDesktop ? `var(--b3-line-height, 32px)` : `var(--b4-line-height, 22px)`};
			letter-spacing: var(--b4-letter-spacing, -0.02em);
			font-weight: var(--b4-font-weight, 400);
		}

		.txt-span5 {
			color: var(--color-black, #101010);
			font-family: 'Noto Sans KR', sans-serif;
			font-size: ${({ $isDesktop }) => $isDesktop ? ` var(--b3-font-size, 16px)` : `var(--b4-font-size, 14px)`};
			line-height: ${({ $isDesktop }) => $isDesktop ? `var(--b3-line-height, 32px)` : `var(--b4-line-height, 22px)`};
			letter-spacing: var(--b4-letter-spacing, -0.02em);
			font-weight: var(--b4-font-weight, 700);
		}
	}

	.mobile-assignment {
		.button {
			p {
				min-width: unset !important;
			}
		}
	}

	.mobile-contents {
		display: flex;
		flex-direction: column;
		gap: 4px;
		align-items: flex-start;
		justify-content: center;
		align-self: stretch;
		flex-shrink: 0;
		position: relative;

		.mobile-assignment {
			display: flex;
			flex-direction: row;
			gap: 8px;
		}

		.contents {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 700;
			position: relative;
			align-self: stretch;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			text-overflow: ellipsis;
			overflow: hidden;
		}
		.divier {
			background: var(--color-grey-c, #e6e8ed);
			align-self: stretch;
			flex-shrink: 0;
			height: 1px;
			position: relative;
		}
		.bottom {
			display: flex;
			flex-direction: column;
			gap: 4px;
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
		}
		.class-name {
			color: var(--color-black, #101010);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			align-self: stretch;
			flex: 1;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			text-overflow: ellipsis;
			overflow: hidden;
		}
		.date {
			display: flex;
			flex-direction: row;
			gap: 4px;
			align-items: flex-start;
			justify-content: flex-start;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;
			color: var(--color-grey-l, #83868a);
			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
			position: relative;
			align-self: stretch;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			text-overflow: ellipsis;
			overflow: hidden;
			white-space: nowrap;
		}
	}

	${props => props.$isHome &&
    props.$isMobile &&
    `
			.mobile_item {
				flex-direction: row !important;
			    justify-content: space-between !important;
			}
			.body-item {
				overflow: hidden;
    			flex: unset !important;

				
			}
		`}

	${props => props.$isHome &&
    `
					.body-item {
						&.creation_time, &.submitDate {
							width: 100px!important;
							flex: unset !important;
	
							p {
								width: 100%;
								text-align: right;
							}
						}
						p {
							display: block;
							overflow: hidden;
							text-overflow: ellipsis;
							word-break: keep-all;
							overflow-wrap: break-word;
    						white-space: nowrap;
							-webkit-line-clamp: 1;
						}
					}
				`}

	.body-item {
		p {
			${props => props.$isDesktop
    ? `
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			letter-spacing: var(--b3-letter-spacing, -0.02em);
			font-weight: var(--b3-font-weight, 400);		
			`
    : props.$isTablet
        ? `
				font-size: var(--b4-font-size, 14px);
				line-height: var(--b4-line-height, 28px);
				letter-spacing: var(--b4-letter-spacing, -0.02em);
				font-weight: var(--b4-font-weight, 400);`
        : `
				font-size: var(--b4-font-size, 12px);
				line-height: var(--b4-line-height, 18px);
				letter-spacing: var(--b4-letter-spacing, -0.02em);
				font-weight: var(--b4-font-weight, 400);`}
		}
	}

	display: flex;
	width: 100%;
	flex-direction: column;
	flex: 1;

	.contents {
		display: flex;
		flex-direction: row;
		gap: 8px;
		align-items: center;
		justify-content: flex-start;
		flex: 1;
		position: relative;
		overflow: hidden;
	}

	.task-list-001 {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		align-self: stretch;
		flex: 1;
		position: relative;
	}

	.student-card-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 24px;
	}

	.student-card-list .card-table-content {
		display: flex;
		flex-wrap: wrap;
		gap: 24px;
		align-items: stretch;
	}

	.student-card-item {
		border: 1px solid var(--color-grey-c, #e6e8ed);
		border-radius: 12px;
		padding: 20px;
		display: flex;
		flex-direction: column;
		gap: 20px;
		background: #fff;
		width: calc(50% - 12px);
	}

	.student-card-head {
		display: flex;
		align-items: center;
		gap: 12px;
	}

	.student-card-badge {
		border-radius: 6px;
		padding: 2px 8px;
		font-size: ${({ $isMobile }) => ($isMobile ? '12px' : '14px')};
		line-height: 1.4;
		font-weight: 500;
		flex-shrink: 0;
	}

	.student-card-badge.created {
		background: #f0f1f4;
		color: var(--color-grey, #666666);
	}

	.student-card-badge.not-submitted {
		background: #61656b;
		color: #fff;
	}

	.student-card-badge.completed {
		background: #458c94;
		color: #fff;
	}

	.student-card-period {
		color: var(--color-black, #101010);
		font-size: 16px;
		line-height: 1.4;
		font-weight: 400;
	}

	.student-card-title {
		color: var(--color-black, #101010);
		font-size: 16px;
		line-height: 1.45;
		font-weight: 500;
		min-height: 2.9em;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
		word-break: keep-all;
	}

	.student-card-button {
		width: 100%;
	}

	.student-card-button.btn_pink p,
	.student-card-button.btn_light_grey p,
	.student-card-button.btn_default p {
		min-width: unset;
		width: 100%;
	}

	/* A4: 학생 카드 핑크(응시) 버튼 그림자 제거 */
	.student-card-button.btn_pink {
		box-shadow: none;
	}

	/* A5: 활성(성적표 보기/결과 보기) = 진한 검정 배경 + 흰 텍스트 */
	.student-card-button.btn_default {
		background-color: #101010;
		color: #fff;
	}
	.student-card-button.btn_default p {
		color: #fff;
	}

	/* A5: 비활성(종료_미응시) = 연한 회색 배경 + 흐린 텍스트 */
	.student-card-button.btn_light_grey {
		background-color: #d7d9dc;
		color: #9398a0;
	}
	.student-card-button.btn_light_grey p {
		color: #9398a0;
	}

	.card-table-more-wrap {
		display: flex;
		justify-content: center;
	}

	.card-table-more p {
		min-width: unset;
	}

	.home-list-003 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			position: relative;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			display: flex;
			position: relative;
			flex-shrink: 0;

			&:nth-last-child(1) {
				border-width: 0px 0px 0px 0px;
			}
		}

		.selected {
			background: #f1f9fa;
			border-width: 0px !important;
		}

		.home-hr {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			width: 100%;
		}
	}

	.underline_blue {
		color: var(--color-tur-p, #2d39aa);
		text-decoration: underline;
		font-family: 'Noto Sans KR', sans-serif;
		letter-spacing: -0.02em;
		font-weight: 400;
		position: relative;

		&.bold {
			font-family: 'Noto Sans KR', sans-serif;
			font-weight: 700 !important;
		}
	}

	.underline_black {
		color: var(--color-black, #101010);
		text-decoration: underline;
	}

	.empty_data {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
	}

	${props => (props.$isDesktop ? desktopStyles : props.$isTablet ? tabletStyles : mobileStyles)}
	${props => props.$isBackOffice && backOfficeStyles}
`;
const mobileStyles = (0, styled_components_1.css) `
	margin-top: ${props => (props.$isHome ? '10px' : 'unset')};

	.txt {
		width: 100%;
		justify-content: center !important;
	}

	&.home {
		height: 100%;
	}

	.btn-container {
		justify-content: center;
		button {
			flex: 1;
		}
	}

	.popup-list-006 {
		${props => props.$isReserve &&
    (0, styled_components_1.css) `
				flex: 1;
				.table-header {
					padding-bottom: 14px;
				}
				.scroll-content {
					max-height: 600px;
					overflow: auto;
				}
			`}

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: center;
			align-self: stretch;
			flex: 1;
			position: relative;
			box-sizing: border-box;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: column;
			gap: 4px;
			align-items: flex-start;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;

			${props => props.$isReserve &&
    (0, styled_components_1.css) `
					&:nth-child(1) {
						border-width: 0px;
					}

					&:nth-last-child(1) {
						border-width: 0px;
					}
				`}

			.date-wrap-mobile {
				display: flex;
				flex-direction: row;
				color: var(--color-grey-l, #83868a);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 12px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
				position: relative;
				align-items: center;
				justify-content: flex-start;
				gap: 4px;
			}

			.status-wrap-mobile {
				display: flex;
				flex-direction: row;
				gap: 4px;

				.status-text {
					color: var(--color-grey-l, #83868a);
				}
			}

			.title-text-mobile {
				display: block;
				color: var(--color-black, #101010);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;

				${({ $isHome }) => !$isHome &&
    `
					font-family: 'Noto Sans KR', sans-serif;
					font-weight: 600;`}
				font-size: 14px;
				line-height: 150%;
				letter-spacing: -0.02em;
				position: relative;
				flex: 1;
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
				-webkit-line-clamp: 1;
				overflow-wrap: break-word;
			}
		}
	}

	.home-list-003 {
		align-self: stretch;

		.item {
			justify-content: center;
			align-items: ${props => (props.$isHome ? 'center' : 'flex-start')};
			align-self: stretch;
			flex-direction: column;
			padding: 10px 6px 10px 6px;
			gap: 24px;
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;
		}

		.title-text-mobile {
			display: block;
			color: var(--color-black, #101010);
			text-align: left;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-family: 'Noto Sans KR', sans-serif;

			${({ $isHome }) => !$isHome &&
    `
			font-family: 'Noto Sans KR', sans-serif;
			font-weight: 600;`} position: relative;
			align-self: stretch;
			align-items: center;
			justify-content: flex-start;
		}
	}

	.task-list-001 {
		padding: 12px 20px;
		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: center;
			align-self: stretch;
			flex: 1;
			position: relative;
			box-sizing: border-box;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			padding: 12px 0px 12px 0px;
			display: flex;
			flex-direction: column;
			gap: 4px;
			align-items: flex-start;
			justify-content: center;
			align-self: stretch;
			flex-shrink: 0;
			position: relative;

			text-align: left;
			font-family: 'Noto Sans KR', sans-serif;
			font-size: 12px;
			line-height: 150%;
			letter-spacing: -0.02em;
			font-weight: 400;

			.date-wrap-mobile {
				display: flex;
				flex-direction: row;
				color: var(--color-grey-l, #83868a);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: 12px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-weight: 400;
				position: relative;
				align-items: center;
				justify-content: flex-start;
				gap: 4px;
			}

			.status-wrap-mobile {
				display: flex;
				flex-direction: row;
				gap: 4px;
				align-items: center;

				.button {
					width: 54px;
					height: 24px;
				}

				.status-text {
					color: var(--color-grey-l, #83868a);
				}
			}

			.title-text-mobile {
				display: block;
				color: var(--color-black, #101010);
				text-align: left;

				font-size: 14px;
				line-height: 150%;
				letter-spacing: -0.02em;
				font-family: 'Noto Sans KR', sans-serif;

				${({ $isHome }) => !$isHome &&
    `
					font-family: 'Noto Sans KR', sans-serif;
					font-weight: 600;`}
				position: relative;
				flex: 1;
				/* display: flex;
				align-items: center;
				justify-content: flex-start; */
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
				-webkit-line-clamp: 1;
				overflow-wrap: break-word;
			}
		}
	}

	${props => props.$isTeacher
    ? (0, styled_components_1.css) `
					.task-list-001 {
						gap: 24px;

						.table-header {
							width: 100%;
							display: flex;
							flex-direction: row;
							gap: 20px;
							align-items: center;
							justify-content: flex-start;
							flex-shrink: 0;
							position: relative;
						}
					}

					.item {
						border-width: 1px 0px 0px 0px;
					}
			  `
    : (0, styled_components_1.css) `
					.task-list-001 {
						border-style: solid;
						border-color: var(--color-silver, #f3f4f8);
						border-width: 1px 0px 0px 0px;
						gap: 0px;
					}

					.item {
						border-width: 0px 0px 1px 0px;
					}
			  `}

	.underline_blue {
		font-size: 14px;
		line-height: 32px;
	}

	.student-card-list {
		padding: 20px;
		gap: 16px;
	}

	.student-card-list .card-table-content {
		gap: 16px;
	}

	.student-card-item {
		width: 100%;
		padding: 16px;
		gap: 16px;
	}

	.student-card-period {
		font-size: 13px;
	}

	.student-card-title {
		font-size: 14px;
	}
`;
const tabletStyles = (0, styled_components_1.css) `
	height: 100%;
	${props => !props.$isTeacher && !props.$isHome && 'padding: 20px;'}

	${props => props.$isReserve && props.$isTest
    ? (0, styled_components_1.css) `
					.popup-list-006 {
						flex: 1;
						height: unset;
						.scroll-content {
							max-height: 600px;
							overflow: auto;
						}
					}
			  `
    : (0, styled_components_1.css) `
					.popup-list-006 {
						overflow: hidden;
						/* flex: 1; */
					}
			  `}

	.popup-list-006 {
		border-style: solid;
		border-color: var(--color-grey-c, #e6e8ed);
		border-width: 0px 0px 1px 0px;
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		flex: 1;

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 16px 12px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}
	}

	.home-list-003 {
		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			padding: 10px 6px 10px 6px;
			display: flex;
			flex-direction: row;
			gap: 24px;
			align-items: flex-start;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b3-font-size, 14px);
				line-height: 150%;
				letter-spacing: var(--b3-letter-spacing, -0.02em);
				font-weight: var(--b3-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}

		.scroll-content {
			flex: 1;
		}

		.item {
			justify-content: flex-start;
			align-items: center;
			padding: 12px 20px;
			flex-direction: row;
			gap: 20px;

			color: var(--color-black, #101010);
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 14px);
			line-height: 150%;
			letter-spacing: var(--b3-letter-spacing, -0.02em);
			font-weight: var(--b3-font-weight, 400);
		}

		.selected {
			border-radius: 40px;
		}
	}

	.task-list-001 {
		gap: 0px;
		/* overflow: auto; */
		height: unset;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			align-self: stretch;
			padding: 12px 20px 12px 20px;
			gap: 24px;
			align-items: center;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				font-size: 14px;
				line-height: 150%;
				letter-spacing: var(--b3-letter-spacing, -0.02em);
				font-weight: var(--b3-font-weight, 400);
				position: relative;
				flex: 1;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			justify-content: flex-start;
			flex: 1;
			position: relative;
			/* overflow: auto; */
			box-sizing: border-box;
			align-self: stretch;
			height: unset;
		}

		.item {
			box-sizing: border-box;
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: ${props => props.$isTeacher || (!props.$isTeacher && props.$isTest)
    ? '12px 20px 12px 20px'
    : '24px 20px 24px 20px'};
			display: flex;
			flex-direction: row;
			gap: 24px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			width: 100%;

			color: var(--color-black, #101010);
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 14px);
			line-height: 150%;
			letter-spacing: var(--b3-letter-spacing, -0.02em);
			font-weight: var(--b3-font-weight, 400);

			.typeText {
				color: var(--color-black, #101010);
				text-align: left;
				font-family: 'Noto Sans KR', sans-serif;
				font-size: var(--b3-font-size, 12px);
				line-height: 150%;
				letter-spacing: var(--b3-letter-spacing, -0.02em);
				font-weight: var(--b3-font-weight, 400);
			}
		}
	}

	.popup-list-006 {
		.table-header {
			width: 100%;
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}
	}

	.underline_blue {
		font-size: 14px;
		line-height: 150%;
		display: flex;
	}

	.student-card-item {
		width: calc(50% - 12px);
	}
`;
const desktopStyles = (0, styled_components_1.css) `
	height: 100%;

	${props => props.$isReserve && props.$isTest
    ? (0, styled_components_1.css) `
					.popup-list-006 {
						flex: 1;
						overflow: hidden;
					}
			  `
    : (0, styled_components_1.css) `
					.popup-list-006 {
						border-style: solid;
						border-color: var(--color-grey-c, #e6e8ed);
						border-width: 0px 0px 1px 0px;
						overflow: hidden;
						flex: 1;
					}
			  `}

	.popup-list-006 {
		display: flex;
		flex-direction: column;
		gap: 0px;
		align-items: flex-start;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		.table-header {
			width: 100%;
			background: var(--color-silver, #f3f4f8);
			border-style: solid;
			border-color: var(--color-grey-w, #b6bac0);
			border-width: 1px 0px 0px 0px;
			padding: 10px 16px 10px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}

		.item {
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 12px 16px 12px 16px;
			display: flex;
			flex-direction: row;
			gap: 20px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
		}
	}

	.home-list-003 {
		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			padding: 10px 6px 10px 6px;
			gap: 24px;
			align-items: flex-start;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b3-font-size, 16px);
				line-height: var(--b3-line-height, 32px);
				letter-spacing: var(--b3-letter-spacing, -0.02em);
				font-weight: var(--b3-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}

		.scroll-content {
			flex: 1;
		}

		.item {
			justify-content: flex-start;
			align-items: center;
			padding: 10px 6px 10px 6px;
			flex-direction: row;
			gap: 24px;

			color: var(--color-black, #101010);
			font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
			font-size: var(--b3-font-size, 16px);
			line-height: var(--b3-line-height, 32px);
			letter-spacing: var(--b3-letter-spacing, -0.02em);
			font-weight: var(--b3-font-weight, 400);
		}

		.selected {
			border-radius: 40px;
		}
	}

	.task-list-001 {
		gap: 0px;
		overflow: auto;
		height: unset;

		.table-header {
			background: var(--color-silver, #f3f4f8);
			border-radius: 40px;
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			align-self: stretch;
			padding: 6px 28px 6px 28px;
			gap: 24px;
			align-items: center;

			p {
				color: var(--color-grey, #666666);
				text-align: left;
				font-family: var(--b3-font-family, 'Noto Sans KR', sans-serif);
				font-size: var(--b3-font-size, 16px);
				line-height: var(--b3-line-height, 32px);
				font-weight: var(--b3-font-weight, 400);
				position: relative;
				display: flex;
				align-items: center;
				justify-content: flex-start;
			}
		}

		.scroll-content {
			display: flex;
			flex-direction: column;
			gap: 0px;
			align-items: flex-start;
			align-self: stretch;
			justify-content: flex-start;
			flex: 1;
			position: relative;
			box-sizing: border-box;
			height: unset;
		}

		.item {
			box-sizing: border-box;
			border-style: solid;
			border-color: var(--color-silver, #f3f4f8);
			border-width: 0px 0px 1px 0px;
			padding: 20px 28px 20px 28px;
			display: flex;
			flex-direction: row;
			gap: 24px;
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			width: 100%;
		}
	}

	.underline_blue {
		font-size: 16px;
		line-height: 32px;

		&.bold {
			font-size: 17px;
		}
	}

	.student-card-item {
		width: calc(50% - 12px);
	}

	${props => props.$isBackOffice && (0, styled_components_1.css) `
		.header {
			.button {
				width: 100px;
				height: 34px;
			}
		}
		.task-list-001 {
			.table-header {
				background: var(--color-silver, #f6f6f6);
				border-radius: 10px;
				border-bottom: none;
				padding: 14px 20px;
			}

			.item {
				padding: 14px 20px;
				border-bottom: 1px solid #d7d9dd;
				height: 56px;
			}
			

		}
	`}
`;
const backOfficeStyles = (0, styled_components_1.css) `
	.assignment-table {
		overflow: unset;
	}

	.task-list-001 {
		overflow: unset;
	}

	.paging {
		position: unset;
	}
`;
